// extracted by mini-css-extract-plugin
export default {"container":"SplashScreen_container__ngZSH"};